import axios from 'axios'

export { API } from './lib/API'
export * as APITypes from './lib/API.types'
export { LogisticsAPI } from './lib/LogisticsAPI'
export * from './lib/Azure'
export { Users } from './lib/Users'
export * as RecordFactory from './lib/record-factory'
export * as ConfigurationFactory from './lib/configuration-factory'

export * from './lib/client-helpers'

export * from './lib/wrapCall'

export * from './lib/types'

export const getCancellationToken = () => axios.CancelToken.source()
